import React, { useCallback, useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import api from "../../api/api";
import Style from "../../assets/css/main.module.css";
import { currencyFormat } from "../../library/currency";
import { setBookingId, setPackageStatus } from "../../store/features/deviceSlice";
import { useDrawer } from "../drawer/DrawerProvider";
import Payment from "../payment/Payment";
import getOrigins from "../../utils/getOrigins";
import useAuthWatcher from "../../hooks/useAuthWatcher";

export default function Package({ item }) {
  const { packageStatus } = useSelector((state) => state.deviceSlice);
  const dispatch = useDispatch();
  const { openDrawer } = useDrawer();
  const [userData, setUserData] = useState(null);
  const handleSignupDrawer = useCallback(() => {
    if (!userData) {
      openDrawer(
        <iframe
          src={`${getOrigins(window)}/login?embed=true`}
          height="100%"
          width="100%"
          title="Login"
        />,
        "",
      );
    }
  }, [userData, openDrawer]);

  const previewDrawerHandler = useCallback(() => {
    openDrawer(<PackagePreview item={item} />, "Package  Preview");
  }, [openDrawer, item]);

  useAuthWatcher(setUserData);

  useEffect(()=>{
      if (packageStatus) {
        previewDrawerHandler();
        dispatch(setPackageStatus(false));
      }
  },[dispatch, userData, previewDrawerHandler, packageStatus])

  return (
    <div className={`${Style.bg_gray_200} pb-2`} style={{ height: "322px" }}>
      <div
        className={`${Style.bg_primary} ${Style.fs_16} ${Style.fw_600} text-light d-flex align-items-center  `}
        style={{ minHeight: "32px", textAlign: "center", justifyContent: "center", textWrap:"wrap" , wordBreak:"break-word"}}
      >
        {item.name}
      </div>
      <div
        className="d-flex flex-column gap-2 px-2"
        style={{ height: "245px", overflow: "hidden" }}
      >
        <div className="text-center pt-2">
          {item.offer_price > 1 ? (
            <div
              className={`${Style.fs_20} ${Style.fw_350} ${Style.text_primary} text-decoration-line-through`}
              style={{
                lineHeight: "26.6px",
              }}
            >
              {currencyFormat(item.price)}
            </div>
          ) : (
            <div
              className={`${Style.fs_20} ${Style.fw_350} ${Style.text_primary} text-decoration-line-through`}
              style={{
                lineHeight: "26.6px",
                height: "28px",
              }}
            />
          )}
          <div
            className={`${Style.fs_48} ${Style.fw_600} ${Style.text_primary}`}
            style={{
              lineHeight: "60px",
              marginTop: "-8px",
            }}
          >
            {currencyFormat(item.offer_price || item.price)}
          </div>
        </div>
        <div
          className={`${Style.fs_16} ${Style.fw_350} ${Style.line_height}   text-start px-3`}
          dangerouslySetInnerHTML={{ __html: item.description }}
        />
      </div>
      <div className="px-4">
        {userData && (
          <button
            type="button"
            onClick={previewDrawerHandler}
            className={`${Style.fs_16} ${Style.fw_600} ${Style.bg_primary} text-light border-0 px-4 w-100 shadow`}
            style={{ height: "34px" }}
          >
            Buy Package
          </button>
        )}
        {!userData && (
          <button
            type="button"
            onClick={handleSignupDrawer}
            className={`${Style.fs_16} ${Style.fw_600} ${Style.bg_primary} text-light border-0 px-4 w-100 shadow`}
            style={{ height: "34px" }}
          >
            Login to Buy
          </button>
        )}
      </div>
    </div>
  );
}
function PackagePreview({ item }) {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { openDrawer } = useDrawer();
  const [userData, setUserData] = useState(null);
  const handlePaymentDrawer = () => {
    openDrawer(<Payment />, "Select Payment Method");
  };
  const confirmPurchase = async () => {
    if (userData) {
      setLoading(true);
      const res = await api.buyPackage({ id: item.id });
      if (res.status === 201) {
        if (res.data?.data?.booking_id) {
          dispatch(setBookingId(res.data.data.booking_id));
          handlePaymentDrawer();
        }
      } else if (res.status === 422) {
        Object.values(res.data.data).forEach((error) => {
          toast.error(error[0]);
        });
      } else {
        toast.error("Server side error!Please try again later");
      }
      setLoading(false);
    }
  };

  useAuthWatcher(setUserData);


  return (
    <div className="w-100 h-100 px-2 px-md-4">
      <div className="userData-container overflow-y-scroll pt-2 pb-2">
        <div
          className={`${Style.bg_gray_200} d-flex flex-column gap-2 px-3 mt-2`}
        >
          <div
            className={`${Style.fs_20} ${Style.fw_400} d-flex align-items-start gap-2`}
          >
            {/* Fixed width for "Package -" */}
            <div
              className={`${Style.fw_600} ${Style.fs_20} text-danger flex-shrink-0`}
            >
              Package - &nbsp;
            </div>

            {/* Expands to take remaining space */}
            <div className={`${Style.fw_400} ${Style.fs_20} flex-grow-1`}>
              {item.name}
            </div>
          </div>
          <div className={`${Style.fw_600} ${Style.fs_20} text-danger`}>
            Description
          </div>
          <div
            className={`${Style.fs_20} ${Style.fw_350}`}
            style={{ lineHeight: "26.6px" }}
            dangerouslySetInnerHTML={{ __html: item.description }}
          />
        </div>
        <div
          className={`${Style.bg_gray_200} d-flex flex-column gap-2 px-3 py-3 mt-2`}
        >
          <div
            className={`${Style.fs_20} ${Style.fw_400} d-flex align-items-center`}
          >
            <div className={`${Style.fw_400} ${Style.fs_20} w-50`}>
              Package Price
            </div>
            <div className={`${Style.fw_400} ${Style.fs_20} w-50 text-end`}>
              {currencyFormat(item.price)}
            </div>
          </div>
          <div
            className={`${Style.fs_20} ${Style.fw_350} text-danger d-flex align-items-center border-bottom border-black`}
          >
            <div className={`${Style.fw_350} ${Style.fs_20} w-50`}>
              Discount Amount
            </div>
            <div className={`${Style.fw_350} ${Style.fs_20} w-50 text-end`}>
              {currencyFormat(
                item.offer_price ? item.price - item.offer_price : 0
              )}
            </div>
          </div>
          <div
            className={`${Style.fs_20} ${Style.fw_600} d-flex align-items-center`}
          >
            <div className={`${Style.fw_600} ${Style.fs_20} w-50`}>
              Grand Total
            </div>
            <div className={`${Style.fw_600} ${Style.fs_20} w-50 text-end`}>
              {currencyFormat(item.offer_price || item.price)}
            </div>
          </div>
        </div>
        <div
          className={`${Style.bg_gray_200} d-flex flex-column gap-2 p-3 mt-2`}
        >
          <div className={`${Style.fw_600} ${Style.fs_20} text-danger`}>
            Terms and Conditions
          </div>
          <div
            className={`${Style.fs_20} ${Style.fw_350}`}
            style={{ lineHeight: "26.6px" }}
            dangerouslySetInnerHTML={{ __html: item.terms }}
          />
        </div>
      </div>
      <div className="package-bottom">
        {!loading && (
          <button
            type="button"
            onClick={confirmPurchase}
            className={`${Style.bg_primary} ${Style.fs_20} ${Style.fw_600} border-0 text-light w-100 cart-checkout-btn`}
          >
            Proceed to Payment
          </button>
        )}
        {loading && (
          <button
            disabled
            type="button"
            className={`${Style.bg_primary} ${Style.fs_20} ${Style.fw_600} border-0 text-light w-100 cart-checkout-btn`}
          >
            <Spinner animation="border" role="status" size="sm">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </button>
        )}
      </div>
    </div>
  );
}
